module.exports = __webpack_public_path__ + "img/ueexbanner.2f32d9f1.png";